import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Button as BaseUIButton } from '@base-ui/react/button';
import { cn } from '../../../utils/utils';
export const IconButton = forwardRef(function IconButton({ className, size = 'md', ...props }, ref) {
    return (_jsx(BaseUIButton, { ...props, ref: ref, className: cn('inline-flex shrink-0 items-center justify-center rounded-md text-neutral-400 transition-colors cursor-pointer hover:bg-neutral-200 hover:text-neutral-700 disabled:cursor-default disabled:text-neutral-300 disabled:hover:bg-transparent', {
            'size-6 [&>svg]:size-4': size === 'sm',
            'size-8 [&>svg]:size-5': size === 'md'
        }, className) }));
});
